import { Coord } from "../../../../../../../src/types/Interface";
import generatePoints from "../../../../../../../src/utils/generator/generatePoints";


export function generateChordPoints(cCoord: Coord, circleRadius: number, pointARadian: number, intersecRadius: number) {
	if (!cCoord || !circleRadius || !pointARadian || !intersecRadius) {
		return Array(3).fill({ x: 0, y: 0 });
	}
	const intersecCoord = generatePoints(cCoord, [pointARadian], intersecRadius)[0];
	const sideLength = Math.sqrt(Math.pow(circleRadius, 2) - Math.pow(intersecRadius, 2));

	const getCoord = (radian: number) => ({
		x: intersecCoord.x + Math.cos(radian) * sideLength,
		y: intersecCoord.y + Math.sin(radian) * sideLength
	});

	return [getCoord(pointARadian + Math.PI / 2), intersecCoord, getCoord(pointARadian - Math.PI / 2)];
}
